
$(".product-single__quantity-label").on( "click", function() { 

  var isSomethingToCart = 0;
    var somethingToCart = {items: []};
    if( $("#doplataZmianaKola").val() == "true") {
      var newItem = {
        'id': 47171602252114,
        'quantity': 1,
        'properties': {'_coverProjectID': $("#tokenInput").val() }
      }; 
      somethingToCart.items.push(newItem);      
      isSomethingToCart = 1;
    } 
    if( $("#kosztMatryca1").length ) {
      var newItem = {
        'id': 47171602153810,
        'quantity': $("#kosztMatryca1").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      }; 
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#kosztMatryca2").length ) {
      var newItem = {
        'id': 47171602186578,
        'quantity': $("#kosztMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);  
      isSomethingToCart = 1;             
    }   
    if( $("#kosztMatryca5").length ) {
      var newItem = {
        'id': 47171602219346,
        'quantity': $("#kosztMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#doplataMatryca2").length ) {
      var newItem = {
        'id': 47189297234258,
        'quantity': $("#doplataMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    }   
    if( $("#doplataMatryca5").length ) {
      var newItem = {
        'id': 47189297267026,
        'quantity': $("#doplataMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem); 
      isSomethingToCart = 1;              
    } 



    console.log("dsadasdasddasdas");
      console.log( somethingToCart);
  });  

  
$(".btn--add-to-cart").on( "click", function() { 
    var isSomethingToCart = 0;
    var somethingToCart = {items: []};
    if( $("#doplataZmianaKola").val() == "true") {
      var newItem = {
        'id': 47171602252114,
        'quantity': 1,
        'properties': {'_coverProjectID': $("#tokenInput").val() }
      }; 
      somethingToCart.items.push(newItem);      
      isSomethingToCart = 1;
    } 
    if( $("#kosztMatryca1").length ) {
      var newItem = {
        'id': 47171602153810,
        'quantity': $("#kosztMatryca1").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      }; 
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#kosztMatryca2").length ) {
      var newItem = {
        'id': 47171602186578,
        'quantity': $("#kosztMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);  
      isSomethingToCart = 1;             
    }   
    if( $("#kosztMatryca5").length ) {
      var newItem = {
        'id': 47171602219346,
        'quantity': $("#kosztMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    } 
    if( $("#doplataMatryca2").length ) {
      var newItem = {
        'id': 47189297234258,
        'quantity': $("#doplataMatryca2").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };   
      somethingToCart.items.push(newItem);    
      isSomethingToCart = 1;           
    }   
    if( $("#doplataMatryca5").length ) {
      var newItem = {
        'id': 47189297267026,
        'quantity': $("#doplataMatryca5").val(),
        'properties': {'_coverProjectID': $("#tokenInput").val() }                
      };
      somethingToCart.items.push(newItem); 
      isSomethingToCart = 1;              
    } 




    
    if( isSomethingToCart > 0 ) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js', // Shopify's cart endpoint
        data: somethingToCart,
        dataType: 'json',
        async: false,              
        success: function(response) {
            //window.location = '/cart';                  
            console.log('Product added to the cart:', response);
            // You can perform actions after adding the product to the cart here
        }
      });     
    }

});
